/* global rcfpSearch */

// Import SCSS
import '../../scss/index.scss';
import './index.scss';

const { selectedItems, searchQuery } = rcfpSearch;

function generateURL(item) {
  let url = `?s=${searchQuery}`;
  if (typeof selectedItems[item.name] === 'undefined') {
    selectedItems[item.name] = [item.value];
  } else {
    const selectedIndex = selectedItems[item.name].indexOf(item.value);
    if (selectedIndex !== -1) { // Remove it if it exists.
      selectedItems[item.name].splice(selectedIndex, 1);
      if (selectedItems[item.name].length === 0) {
        delete selectedItems[item.name];
      }
    } else {
      selectedItems[item.name].push(item.value);
    }
  }
  // eslint-disable-next-line no-restricted-syntax, no-unused-vars
  for (const [key, value] of Object.entries(selectedItems)) {
    url += `&${key}=${value.join('+')}`;
  }
  return url;
}

const searchItems = document.getElementsByClassName('search-item');
Array.from(searchItems).forEach((searchItem) => {
  searchItem.addEventListener('click', (e) => {
    e.preventDefault();
    const item = e.target;
    const url = generateURL(item);

    // FadeOut.
    document.getElementsByClassName('page-search__wrapper')[0]
      .style.opacity = 0.25;
    document.getElementById('faceted_search_form')
      .style.opacity = 0.25;

    fetch(url)
      .then((data) => data.text())
      .then((response) => {
        // FadeIn.
        document.getElementsByClassName('page-search__wrapper')[0]
          .style.opacity = 1;
        document.getElementById('faceted_search_form')
          .style.opacity = 1;
        // re-writes the entire document
        const newDoc = document.open('text/html', 'replace');
        newDoc.write(response);
        newDoc.close();
        window.history.pushState('page2', 'Search Results', url);
      });
  });
});

if (module.hot) {
  module.hot.accept();
}
